import React from "react";
import PatientCaseSheet from "../../InPatientsNew/PatientCaseSheet";

function CaseSheet({
  isOpen = true,
  onClose,
  appointmentDetails,
  patientDetails,
  onSave,
}) {
  if (!isOpen) return null;

  const patient = appointmentDetails || patientDetails || {};
  const resolvedPatientId =
    patient?.patientId ||
    patient?.patientCode ||
    patient?.uhid ||
    "";
  const resolvedAdmissionNo =
    patient?.admissionNo ||
    patient?.admissionNumber ||
    patient?.admissionId ||
    "";

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-xs overflow-y-auto animate-fadeIn"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl shadow-2xl border border-gray-100 w-full max-w-5xl max-h-[92vh] flex flex-col overflow-hidden my-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex-1 overflow-y-auto p-2 sm:p-3 bg-gray-50/50">
          <PatientCaseSheet
            patientDetails={patient}
            patientId={resolvedPatientId}
            admissionId={resolvedAdmissionNo}
            onClose={onClose}
            onSave={onSave}
          />
        </div>
      </div>
    </div>
  );
}

export default CaseSheet;
